import { toFormikValidationSchema } from "zod-formik-adapter";

import type { IShapeOf, IShapeOfForm } from "@utils";
import { getDefaultPhoneCode, z } from "@utils";
import type { IPhoneNumber } from "@components/formControls";

export interface ISendEmailFormValues {
  isEmail: boolean;
  email: string;
  phone: IPhoneNumber;
  items: { type: "phone" | "email"; value: string }[];
}

export const SendEmailInitialValues: ISendEmailFormValues = {
  email: "",
  phone: { code: getDefaultPhoneCode(), number: "" },
  isEmail: false,
  items: [],
};

const emailSchema = z.object<IShapeOfForm<ISendEmailFormValues>>({
  email: z.email(),
});

const phoneSchema = z.object<IShapeOfForm<ISendEmailFormValues>>({
  phone: z.phone(),
});

export const SendEmailSchema = toFormikValidationSchema(
  z
    .object<IShapeOf<ISendEmailFormValues>>({
      email: z.email().optional(),
      phone: z.phone(true),
      isEmail: z.boolean().optional(),
    })
    .superRefine((data, ctx) => {
      try {
        if (data?.isEmail) emailSchema.parse(data);
        else phoneSchema.parse(data);
      } catch (error) {
        if (error instanceof z.ZodError) {
          for (const err of error?.errors || []) {
            ctx.addIssue(err);
          }
        }
      }
    }),
);
